import { NavLink, useParams } from "react-router-dom";
import { useComponentTranslation } from "@/services/i18n";

const translations = {
  en: {
    job: "The Job",
    application: "Application",
    distribution: "Channels",
  },
  fr: {
    job: "Le poste",
    application: "Candidature",
    distribution: "Canaux",
  },
};

export default function AdTabs() {
  const { t } = useComponentTranslation(translations);
  const { id } = useParams();

  const tabs = [
    { to: `/recruiter/job-ads/${id}/ad/job`, label: t("job") },
    { to: `/recruiter/job-ads/${id}/ad/application`, label: t("application") },
    { to: `/recruiter/job-ads/${id}/ad/distribution`, label: t("distribution") },
  ];

  return (
    <div className="flex gap-6 px-6 border-b border-gray-200 bg-white shrink-0">
      {tabs.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          className={({ isActive }) =>
            `py-3 text-sm font-medium border-b-2 transition-colors ${
              isActive ? "border-blue-600 text-blue-600" : "border-transparent text-gray-500 hover:text-gray-700"
            }`
          }
        >
          {tab.label}
        </NavLink>
      ))}
    </div>
  );
}
